// assets/product-badges.js - Alternative version
(function() {
  'use strict';

  // Function to shuffle array (Fisher-Yates algorithm)
  function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  // Function to get colors ensuring no duplicates on same card
  function getCardColors(colorList, badgeCount) {
    if (!colorList) return [];
    
    let colors = colorList.split(',').map(c => c.trim());
    
    // Shuffle colors for randomness
    colors = shuffleArray([...colors]);
    
    // If we have more badges than colors, we need to repeat but ensure they're different
    if (badgeCount > colors.length) {
      // Create enough colors by repeating and shuffling
      const repeatCount = Math.ceil(badgeCount / colors.length);
      let extendedColors = [];
      
      for (let i = 0; i < repeatCount; i++) {
        // Shuffle each repetition for variety
        const shuffledCopy = shuffleArray([...colors]);
        extendedColors = [...extendedColors, ...shuffledCopy];
      }
      
      return extendedColors.slice(0, badgeCount);
    }
    
    // If we have enough colors, just return the first N after shuffling
    return colors.slice(0, badgeCount);
  }

  // Function to apply random colors to badges
  function applyRandomColors() {
    console.log('Applying random colors to badges...');
    
    const badgeContainers = document.querySelectorAll('.product-badges-container');
    
    badgeContainers.forEach(container => {
      const useRandomColors = container.dataset.randomColors === 'true';
      const colorList = container.dataset.colorList;
      
      if (!useRandomColors || !colorList) return;
      
      const badges = container.querySelectorAll('.product-badge');
      if (badges.length === 0) return;
      
      // Get colors for this card (ensuring no duplicates if possible)
      const cardColors = getCardColors(colorList, badges.length);
      
      badges.forEach((badge, index) => {
        // Use the pre-determined color for this badge
        if (cardColors[index]) {
          badge.style.setProperty('--badge-bg', cardColors[index]);
        }
      });
    });
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyRandomColors);
  } else {
    applyRandomColors();
  }

  // For Shopify editor/section updates
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', applyRandomColors);
  }

  // MutationObserver for dynamic content
  const observer = new MutationObserver(applyRandomColors);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();